// extracted by mini-css-extract-plugin
export var column = "FormGrid-module--column--8a205";
export var fadeInAnimation = "FormGrid-module--fadeInAnimation--33760";
export var formGrid = "FormGrid-module--formGrid--b2015";
export var row = "FormGrid-module--row--89ea9";
export var section = "FormGrid-module--section--8de35";
export var titleWrap = "FormGrid-module--titleWrap--4c5d0";